<template>
    <div>
        <div class="text-center" v-show="loadingOverlay">
            <v-progress-circular
                    :width="3"
                    color="blue"
                    indeterminate="">
            </v-progress-circular>
        </div>
        <div v-show="!loadingOverlay">
            <v-treeview
                    :items="rolesTree"
                    :open-all="true"
                    item-children="roles"
                    item-text="name"
                    :selectable="true"
                    v-model="tree"
                    item-key="id"></v-treeview>

            <v-btn @click="save"
                color="success"
                :disabled="overlay">
                Save</v-btn>
        </div>
    </div>
</template>

<script>

    import api from '@/api';
    import {validationMixin} from '@/mixins/validations'

    export default {
        inject : ['getProvidedUser'],
        mixins:[validationMixin],
        data() {
            return {
                rolesTree : [],
                tree : [],
                user : {},
                overlay : false,
                loadingOverlay:true
            }
        },
        mounted() {
            this.user = this.getProvidedUser();
            this.get();
        },
        methods: {
            get() {
                this.loadingOverlay = true;
                api.user.role.get(this.user.id).then((roles) => {
                    this.rolesTree = roles;
                    this.tree = [];
                    this.rolesTree.forEach((app) => {
                        app.roles.forEach((r) => {
                            if (r.selected) {
                                this.tree.push(r.id);
                            }
                        });
                    });
                    this.loadingOverlay = false;
                });
            },
            save() {
                this.overlay = true;
                let roles  = [];
                this.tree.forEach((t) => {
                   if (t.indexOf("ROLE_") > -1) {
                       roles.push(t.substring(5));
                   }
                });
                api.user.role.post(this.user.id,roles).then(() => {
                    if (this.user.id == this.$userHolder.getUserId()) {
                        this.$permissionHolder.load();
                    }
                    this.$root.$emit('globalMessage','Roles Updated');
                    this.$root.$emit('userRolesUpdated');
                    this.get();
                }, (error) => {
                    this.processErrors(error);
                }).finally(this.overlay = false);
            }
        }
    }
</script>